import { render, staticRenderFns } from "./copyListPage.vue?vue&type=template&id=0543d7c2&scoped=true"
import script from "./copyListPage.vue?vue&type=script&lang=js"
export * from "./copyListPage.vue?vue&type=script&lang=js"
import style0 from "./copyListPage.vue?vue&type=style&index=0&id=0543d7c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0543d7c2",
  null
  
)

export default component.exports